export default __webpack_public_path__ + "b05e2b51e1fde29b570be7c6db0cce7a.png";